/**
 * Discount types that indicate a route is already priced with dynamic pricing.
 * @type {Set<string>}
 */
export const dynamicPricingDiscountTypes = new Set([
  'dynamic_pricing',
  'dynamic_pricing_single_on_round_trip_discount',
]);

/**
 * Determines whether a purchase uses dynamic pricing based on its leg discount types.
 * @param {string} [departDiscountType] - Discount type of the departing leg.
 * @param {string} [returnDiscountType] - Discount type of the returning leg.
 * @returns {boolean} True if either leg uses a dynamic pricing discount type.
 */
export function getHasDynamicPricing(departDiscountType, returnDiscountType) {
  return (
    dynamicPricingDiscountTypes.has(departDiscountType) ||
    dynamicPricingDiscountTypes.has(returnDiscountType)
  );
}
